import { Box } from 'components/Stack';
import Text from 'components/Text';
import { memo } from 'react';
import styled, { useTheme } from 'styled-components';

type SimpleSeatType = {
    number: number | string;
    bgColor?: string;
    fgColor?: string;
    disabled?: boolean;
}

const SimpleSeat = ({ number: seatNumber, bgColor, fgColor }: SimpleSeatType) => {
    const { color } = useTheme();

    bgColor = bgColor || color.grey100;
    fgColor = fgColor || color.grey800;

    const border = `1px solid ${fgColor}` || '';

    return <Box className='cursor' $width='32px' $height='32px' $alignItems='center' $justifyContent='center'
        $bgColor={bgColor} $fgColor={fgColor}
        $border={border} $borderRadius='10px'>
        <Text>{seatNumber}</Text>
    </Box>
}

export default memo(SimpleSeat);